import { TReactSelectOption } from "components/ProjectNonSpecificComponents/Elements/FormBuilder/FormBuilder"
import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import { usePTKMStore } from "components/ProjectSpecificComponents/Contexts/PTKMStoreContext"
import {
	isReactSelectSingleOption,
	TReactSelectSelectedOptions,
} from "components/ProjectSpecificComponents/Interfaces/ExternalComponentsInterfaces"
import { IFormsConfig } from "components/ProjectSpecificComponents/Interfaces/FormsInterface"
import { IptkmFormConfig } from "components/ProjectSpecificComponents/Stores/PTKMStore/ptkmStore"
import { observer } from "mobx-react-lite"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import HorizontalFormField from "../AdminForm/molecules/HorizontalFormField"
import Select from "../Global/atoms/Select"

interface Props {
	type: "PTKM" | "REQUEST"
}

const CopyConfigFromList = observer(({ type }: Props) => {
	const { t } = useTranslation()
	const formStore = useFormStore()
	const ptkmStore = usePTKMStore()

	const { formsConfigsPTKM } = ptkmStore.settings
	const { formsConfigs } = formStore.settingsData

	const [selectedConfig, setSelectedConfig] = useState<TReactSelectOption | undefined>()

	useEffect(() => {
		formStore.setCopiedConfig(undefined)
		ptkmStore.setCopiedConfig(undefined)
	}, [])

	const parseForSelect = (cnfg: IptkmFormConfig | IFormsConfig) => ({
		value: String(cnfg.id),
		label: String(cnfg.name ?? ""),
		extraProp: JSON.stringify(cnfg),
	})

	const configList: TReactSelectOption[] | undefined =
		type === "PTKM"
			? formsConfigsPTKM?.map(parseForSelect)
			: type === "REQUEST"
			? formsConfigs?.map(parseForSelect)
			: []

	const toggleConfig = (selectedOption: TReactSelectSelectedOptions) => {
		if (isReactSelectSingleOption(selectedOption)) {
			setSelectedConfig(selectedOption)
			switch (type) {
				case "PTKM":
					ptkmStore.setCopiedConfig(JSON.parse(selectedOption.extraProp))
					return
				case "REQUEST":
					formStore.setCopiedConfig(JSON.parse(selectedOption.extraProp))
					return
				default:
					return
			}
		} else {
			setSelectedConfig(undefined)

			switch (type) {
				case "PTKM":
					ptkmStore.setCopiedConfig(undefined)
					return
				case "REQUEST":
					formStore.setCopiedConfig(undefined)
					return
				default:
					return
			}
		}
	}

	return (
		<>
			{configList.length > 0 && (
				<HorizontalFormField
					containerStyle={{ padding: "20px 16px" }}
					label={t(`forms.field-label.copy-cnfg`)}
					centerSpaceMultiplier={0.5}
					tooltipBelowInputField
				>
					<Select options={configList} value={selectedConfig} onChange={toggleConfig} />
				</HorizontalFormField>
			)}
		</>
	)
})

export default CopyConfigFromList
